import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_snap_select_menu = _resolveComponent("snap-select-menu")!

  return (_openBlock(), _createBlock(_component_snap_select_menu, _mergeProps(_ctx.attrs, {
    ".selectMenuOptions": _ctx.selectMenuOptions,
    onSnapSelectMenuUpdated: _ctx.onSelectMenuUpdated
  }), null, 48, [".selectMenuOptions", "onSnapSelectMenuUpdated"]))
}